//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UserLoginMixin } from "@/mixins";
import { orderList } from "@/model/javaApi/default";
import InfiniteScroll from "@/directives/infinite_scroll";
import { get, isNumber } from "lodash";
import { OrderStatus } from "./config";
export default {
  name: "my-insurance",
  mixins: [UserLoginMixin],
  directives: {
    InfiniteScroll,
  },
  data() {
    return {
      tabs: [
        {
          name: "全部",
          key: "all",
        },
        {
          name: "待付款",
          key: OrderStatus.unpay,
        },
        {
          name: "待生效",
          key: OrderStatus.effectPending,
        },
        {
          name: "保障中",
          key: OrderStatus.guaranteeing,
        },
        {
          name: "退款/终止",
          key: OrderStatus.expired,
        },
      ],
      listLoading: false,
      list: [],
      pageNum: 0,
      OrderStatus,
      disabledLoadMore: false,
      loaded: false,
    };
  },
  created() {
    if (!this.logined) {
      this.STATISTICS("load", "insur_orderlist_page", "jr", {
        ex: {
          status: "未登录",
        },
      });
      this.disabledLoadMore = true;
      this.loaded = true;
      return;
    }
  },
  computed: {
    isEmpty() {
      return this.list.length === 0;
    },
    activeTabKey() {
      return this.$route.query.activeTabKey || "all";
    },
  },
  watch: {
    activeTabKey() {
      this.list = [];
      this.$nextTick(() => {
        this.loadList();
      });
    },
  },
  methods: {
    loadListAuto() {
      this.pageNum = this.pageNum + 1;
      this.$nextTick(() => {
        this.loadList();
      });
    },
    loadList() {
      const params = {
        orderStatus:
          this.activeTabKey === "all" ? undefined : this.activeTabKey,
        pageNum: this.pageNum,
      };
      this.listLoading = true;
      orderList(params)
        .then((res) => {
          const list = get(res, "records");
          const current = get(res, "current");
          const pageSize = get(res, "size");
          if (Array.isArray(list)) {
            this.list = [...this.list, ...list];
            this.disabledLoadMore =
              list.length === 0 ||
              (isNumber(pageSize) && list.length < pageSize);
          }
          this.pageNum = typeof current === "number" ? current : 1;
          if (!this.loaded) {
            this.STATISTICS("load", "insur_orderlist_page", "jr", {
              ex: {
                status:
                  Array.isArray(list) && list.length > 0 ? "有数据" : "无数据",
              },
            });
            this.loaded = true;
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    onTabChange(tab) {
      const { path, query } = this.$route;
      this.$router.replace({
        path,
        query: {
          ...query,
          activeTabKey: tab.key,
        },
      });
    },
    onLogin() {
      this.$refs.userLoginDialog.showoast();
    },
    onLoginSuccess() {
      this.loadListAuto();
    },
    toDetail(item) {
      this.STATISTICS("click", "insur_orderlist_orderdetail_click", "jr");
      this.$router.push({
        path: "/orderDetail",
        query: {
          uuid: item.uuid,
          templateFlag: item.tmpl,
          pid: item.channel_id,
          insureType: item.type,
          source: "insurance_list",
          orderNo: item.orderNo,
        },
      });
    },
    toPay(item) {
      this.STATISTICS("click", "insur_orderlist_pay_click", "jr");
      this.$router.push({
        path: "/detailPay",
        query: {
          // 订单号
          outTradeNo: item.outTradeNo,
          baseNo: item.baseNo, //主站订单号 没有则为空
          flag: "postdisable",
          pid: "",
          ch: "",
        },
      });
    },
  },
};
